import React, { useCallback } from "react";
import styled from "styled-components";
import { Form, Row, Col } from "react-bootstrap";
import { useRouter } from "next/router";

import { hexToRGBA } from "../../../utils/theme";

import TrademarkGeneralInfoBlock from "../input-blocks/TrademarkGeneralInfoBlock";
import TrademarkOwnerInfoBlock from "../input-blocks/TrademarkOwnerInfoBlock";
import TrademarkClassInfoBlock from "../input-blocks/TrademarkClassInfoBlock";
import StyledButton from "../../styled/StyledButton";

const StyledTrademarkUpsellForm = styled(Form)`
  padding-bottom: 62px;

  .inputs-block-title {
    margin-bottom: 32px;
    padding-left: 24px;
    padding-right: 24px;

    font-family: 'MerriweatherLight';
    font-size: 24px;
    line-height: 30px;
    text-align: center;
    text-transform: capitalize;
    color: #1B3858;
    text-shadow: 1px 1px 0px #FFFFFF;

    span {
      span {
        color: #C61F0C;
      }
    }
  }

  .input-title {
    margin-bottom: 4px;
    font-family: 'LatoRegular';
    font-size: 14px;
    line-height: 24px;
    color: ${hexToRGBA('#1B3858', 0.7)};
    caret-color: ${hexToRGBA('#1B3858', 0.7)};

    > i {
      display: inline-block;
      right: unset;

      &:hover {
        color: inherit;
        cursor: auto;
      }
    }
  }

  .inputs-block-divider {
    margin-bottom: 46px;
  }

  .input-title-divider {
    margin-bottom: 16px;
  }

  .top-disclaimer {
    font-family: 'MerriweatherLight';
    font-size: 16px;
    line-height: 26px;
    text-align: center;
    color: #1B3858;

    span {
      display: block;
      margin-top: 16px;
      margin-bottom: 16px;
    }
  }

  .bottom-disclaimer {
    font-family: 'LatoRegular';
    font-size: 10px;
    line-height: 22px;
    text-align: center;
    color: #1B3858;
    opacity: 0.5;
    text-shadow: 1px 1px 0px #FFFFFF;
  }

  button {
    width: 100%;
    margin-bottom: 1rem;
  }

  @media ${({ theme }) => theme.devices.tablet} {
    padding-bottom: 42px;

    .input-title {
      position: relative;
      margin-bottom: 24px;

      > i {
        position: absolute;
        top: auto;
        bottom: -28px;
      }
    }
  }
`;

function TrademarkUpsellForm({
  values = {},
  onAddOwner,
  onRemoveOwner,
  onAddClass,
  onRemoveClass,
  onChange,
  onSubmit,
}) {
  const router = useRouter();

  const handleSubmitButtonMouseDown = useCallback(() => {
    onChange && onChange({ target: { id: "suspendedSubmit", value: true } });
  }, [onChange]);

  const handleCancel = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    router.push("MonexaUpsellQuestion");
  }, [router]);

  return (
    <StyledTrademarkUpsellForm
      id="TrademarkUpsellForm"
      noValidate
      validated={values.validated}
      onSubmit={onSubmit}
    >
      <TrademarkGeneralInfoBlock
        values={values}
        onChange={onChange}
      />
      <TrademarkOwnerInfoBlock
        values={values}
        onAddOwner={onAddOwner}
        onRemoveOwner={onRemoveOwner}
        onChange={onChange}
      />
      <TrademarkClassInfoBlock
        values={values}
        onAddClass={onAddClass}
        onRemoveClass={onRemoveClass}
        onChange={onChange}
      />
      <Row>
        <Col xs={12}>
          <div className="inputs-block-divider" />
        </Col>
        <Col xs={0} md={3} />
        <Col xs={12} md={6}>
          <StyledButton
            type="submit"
            id="TrademarkUpsellSubmitButton"
            onMouseDown={handleSubmitButtonMouseDown}
          >
            Submit Order
          </StyledButton>
        </Col>
        <Col xs={0} md={3} />
        <Col xs={0} md={3} />
        <Col xs={12} md={6}>
          <StyledButton
            secondary
            onClick={handleCancel}
          >
            Nevermind, I don’t need a Trademark
          </StyledButton>
        </Col>
        <Col xs={0} md={3} />
      </Row>
    </StyledTrademarkUpsellForm>
  );
}

export default TrademarkUpsellForm;
